<template lang="pug">

    div

        //- Headline
        //- .ui.top.attached.header Angebote für Produkt {{ productModel.zmuekId }} bearbeiten
            //- .ui.grid
            //-     .ten.wide.column
            //-         h2.ui.header
            //-             i.calculator.icon
            //-             .content Angebote für Produkt {{ productModel.zmuekId }}
            //-     .right.aligned.six.wide.column(v-if="canBeProduced")
            //-         set-status-in-production-button(:job-model='jobModel')

        .ui.attached.yellow.icon.message(v-if="orderConfirmationRequestModel")
            i.exclamation.circle.icon
            .content
                .header Es wurde eine Auftragsbestätigung angefordert
                p
                    span Laden Sie die Auftragsbestätigung bitte
                    a(:href='orderConfirmationRequestUploadLink' target='_blank')  hier
                    span  hoch


        .ui.attached.yellow.icon.message(v-if="canBeProduced")
            i.exclamation.circle.icon
            .content
                .header Der Job ist noch nicht als "In Produktion" markiert
                p Befindet sich der Job in Produktion, dann bitte den entsprechenden Button oben rechts drücken.

        product-summary(
            :product-model='productModel'
            :media-production-person-model='mediaProductionPersonModel'
            :product-type-model='productTypeModel'
        )

        //- Content
        .ui.segment

            navigation(v-bind:offer-model='activeOffer' v-bind:job-model="jobModel")

            .ui.secondary.pointing.menu
                router-link.item(
                    v-for='offer in offers'
                    v-bind:key='offer.id'
                    v-bind:to='{ name: "jobs/update", params: { jobId: jobModel.id, offerId: offer.id }}'
                ) Variante {{ getVariantByOffer(offer).number }}

            price-table(
                v-bind:job-model='jobModel'
                v-bind:offer-model='activeOffer'
                v-bind:price-models='activePriceModels'
            )

            div.ui.basic.segment
                variant-details(
                    v-bind:label-width='50'
                    v-bind:field-models='activeFieldModels'
                    v-bind:form-model='formModel'
                    v-bind:product-type-model='productTypeModel'
                    v-bind:variant-model='activeVariantModel'
                )

</template>

<script>
    import * as R from 'ramda'
    import store from '@/store'
    import { type_id_to_form_id } from '@/utils/form'
    import Navigation from '@/components/offers/Navigation'
    import PriceTable from '@/components/offers/PriceTable'
    import ProductSummary from '@/components/offers/Summary'
    import SetStatusInProductionButton from '@/components/offers/SetStatusInProductionButton'
    import VariantDetails from '@/components/products/VariantDetails'

    //noinspection JSUnusedLocalSymbols,JSUnusedGlobalSymbols
    export default {

        async beforeRouteEnter(to, from, next) {
            // Angebot laden
            const offerModel = await store.dispatch('offers/loadOne', { id: to.params.offerId })

            // Job laden
            const jobModel = await store.dispatch('jobs/loadOne', { id: offerModel.job })

            // Produkt und Angebote des Jobs laden
            const [ productModel, offerModels ] = await Promise.all([

                // Produkt laden
                store.dispatch('products/loadOne', { id: jobModel.product }),

                // Angebote laden
                store.dispatch('offers/loadAllByIds', { ids: jobModel.offers })

            ])

            // Wenn Produkt akzeptiert wurde, dann evt. vorhandene Auftragsbestätungsanfrage laden
            if (productModel.status === 'OFFER_CONFIRMED') {
                // Akzeptierten Preis laden
                const priceModel = await store.dispatch('prices/loadOne', { id: productModel.price })

                // ggf. Auftragsbestätungsanfrage laden
                const orderConfirmationRequestId = R.prop('orderConfirmationRequest', priceModel)
                if (priceModel.isOrderConfirmationRequired && R.is(Number, orderConfirmationRequestId)) {
                    await store.dispatch('orderConfirmationRequests/loadOne', { id: orderConfirmationRequestId })
                }
            }

            // Varianten laden
            const variantModels = await store.dispatch('variants/loadAllByOfferModels', { offerModels })

            await Promise.all([

                // Produkt-Typ laden
                store.dispatch('productTypes/loadOne', { id: productModel.type }),

                // Formular laden
                store.dispatch('forms/loadOne', { id: type_id_to_form_id(productModel.type) }),

                // Alle Preise laden
                store.dispatch('prices/loadAllByOfferModels', { offerModels }),

                // Felder laden
                store.dispatch('fields/loadAllByVariantModels', { variantModels }),

                // Medienproduktioner-Person laden
                store.dispatch('persons/loadOneByUserId', { userId: productModel.mediaProduction })

            ])

            next()
        },

        components: { Navigation, PriceTable, ProductSummary, SetStatusInProductionButton, VariantDetails },

        computed: {

            acceptedPriceModel() {
                const priceId = R.prop('price', this.productModel)
                return store.getters['prices/byId'](priceId)
            },

            activeFieldModels() {
                return store.getters['fields/allByVariantId'](this.activeVariantModel.id)
            },

            activeOffer() {
                const offerId = R.prop('offerId', this.$route.params)
                return store.getters['offers/byId'](offerId)
            },

            activePriceModels() {
                return R.map(store.getters['prices/byId'], this.activeOffer.prices)
            },

            activeVariantModel() {
                return R.find(R.propEq('id', this.activeOffer.variant), this.variants)
            },

            canBeProduced() {
                return R.propEq('status', 'OFFER_CONFIRMED', this.productModel)
                    && R.propEq('status', 'ACCEPTED', this.jobModel)
            },

            formModel() {
                const formId = type_id_to_form_id(this.productModel.type)
                return store.getters['forms/byId'](formId)
            },

            jobModel() {
                return store.getters['jobs/byId'](this.activeOffer.job)
            },

            mediaProductionPersonModel() {
                return store.getters['persons/byUserId'](this.productModel.mediaProduction)
            },

            offers() {
                return store.getters['offers/allByJobId'](this.jobModel.id)
            },

            orderConfirmationRequestModel() {
                const orderConfirmationRequestId = R.prop('orderConfirmationRequest', this.acceptedPriceModel)
                return store.getters['orderConfirmationRequests/byId'](orderConfirmationRequestId)
            },

            orderConfirmationRequestUploadLink() {
                const id = R.prop('id', this.orderConfirmationRequestModel)
                const uploadId = R.prop('upload', this.orderConfirmationRequestModel)
                const accessKey = R.prop('accessKey', this.orderConfirmationRequestModel)
                return `/uploads/order-confirmations/${id}/${uploadId}?access-key=${accessKey}`
            },

            prices() {
                return this.activeOffer.prices
                    .map(id => store.getters['prices/byId'](id))
            },

            productModel() {
                return store.getters['products/byId'](this.jobModel.product)
            },

            productTypeModel() {
                return store.getters['productTypes/byId'](this.productModel.type)
            },

            variants() {
                return store.getters['variants/allByOffers'](this.offers)
            }

        },

        mounted() {
            this._connectSse()
            this._connectProductSse()
        },

        beforeDestroy() {
            this._disconnectSse()
            this._disconnectProductSse()
        },

        methods: {

            getVariantByOffer(offer) {
                return this.variants.find(variant => variant.id === offer.variant)
            },

            async _connectSse() {
                try {
                    const token = await store.dispatch('offers/getSseToken')
                    const jobId = this.jobModel.id
                    const es = new EventSource(`/api/v1/offers/events?jobId=${jobId}&token=${token}`)

                    es.addEventListener('job-updated', () => {
                        store.dispatch('jobs/loadOne', { id: jobId, force: true })
                        store.dispatch('offers/loadAllByIds', { ids: this.jobModel.offers, force: true })
                    })

                    es.onerror = () => {
                        es.close()
                        // Nach kurzer Pause neue Verbindung mit frischem Token aufbauen
                        this._sseReconnectTimer = setTimeout(() => this._connectSse(), 5000)
                    }

                    this._sseConnection = es
                } catch (e) {
                    // Stiller Fehler – SSE ist optional, Seite funktioniert auch ohne
                }
            },

            _disconnectSse() {
                clearTimeout(this._sseReconnectTimer)
                if (this._sseConnection) {
                    this._sseConnection.close()
                    this._sseConnection = null
                }
            },

            async _connectProductSse() {
                try {
                    const token = await store.dispatch('products/getSseToken')
                    const productId = this.jobModel.product
                    const es = new EventSource(`/api/v1/products/events?productId=${productId}&token=${token}`)

                    es.addEventListener('product-updated', () => {
                        store.dispatch('products/loadOne', { id: productId, force: true })
                    })

                    es.onerror = () => {
                        es.close()
                        this._productSseReconnectTimer = setTimeout(() => this._connectProductSse(), 5000)
                    }

                    this._productSseConnection = es
                } catch (e) {
                    // Stiller Fehler – SSE ist optional, Seite funktioniert auch ohne
                }
            },

            _disconnectProductSse() {
                clearTimeout(this._productSseReconnectTimer)
                if (this._productSseConnection) {
                    this._productSseConnection.close()
                    this._productSseConnection = null
                }
            }

        }

    }

</script>

<!--suppress CssUnusedSymbol -->
<style scoped>

    .yellow.message {
        box-shadow: none !important;
        border: 1px rgb(212, 212, 213) solid !important;
    }

</style>
